var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Department-595b40b75ba036ed117d7c30-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    fill: "currentColor",
    d: "m25.8 0.2l22.5 7.5 1.7 0.5v41.8h-50v-41.8l1.7-0.5 22.5-7.5 0.8-0.4zm-20.8 11.7v33.2h22.5v-10h10v10h7.5v-33.2l-20-6.7zm7.5 3.2h10v5h-10zm15 0h10v5h-10zm-15 10h10v5h-10zm15 0h10v5h-10zm-15 10h10v5h-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractor);
export default __webpack_public_path__ + "static/media/contractor.29a62ea33283efa596014541db968954.svg";
export { ForwardRef as ReactComponent };